/* eslint-disable react/jsx-one-expression-per-line */
import { SmlsCheckbox } from '@smiles/smiles-ui-kit-react';
import { useTranslation } from 'react-i18next';
import { useMemberData } from 'pages/FirstAccessFlow/context/MemberDataContext';
import React, { useState } from 'react';

export function AcceptTerms() {
  const { handler, openTerms } = useMemberData();
  const { t, i18n } = useTranslation('terms');

  const [isChecked, setIsChecked] = useState<boolean>(false);

  const handleTermsChange = (e: React.MouseEvent<HTMLInputElement>) => {
    setIsChecked((prev) => {
      handler({ terms: !prev });
      return !prev;
    });
  };

  return (
    <div className="accept-terms" data-testid="first-access-accept-terms">
      <div className={`terms-checkbox-container ${isChecked ? 'checked' : ''}`} onClick={handleTermsChange}>
        <SmlsCheckbox label="" checked={isChecked} data-testid="first-access-accept-terms-checkbox" />
      </div>
      <div className="terms-text" data-testid="first-access-accept-terms-text">
        <span>
          {t('agree_part1')}{' '}
          <a
            href={`${window.location.origin}/regulamento-do-programa-smiles-novo`}
            data-testid="first-access-smiles-rules-link"
            target="_blank"
            rel="nofollow noreferrer"
          >
            {t('smiles_rules')}
          </a>
          , {t('agree_part2')}
          <a
            href={`${window.location.origin}/portal/termos-condicoes-acesso-unico`}
            onClick={() => {
              openTerms();
            }}
            target="_blank"
            rel="nofollow noreferrer"
            data-testid="first-access-terms-and-conditions-link"
          >
            {' '}
            {t('terms_and_conditions')} {i18n.language !== 'en' && ' '}
          </a>
          {t('agree_part3')}{' '}
          <a
            href={`${window.location.origin}/privacidade`}
            target="_blank"
            rel="nofollow noreferrer"
            data-testid="first-access-privacy-policy-link"
          >
            {t('privacy_policy')}.
          </a>
        </span>
      </div>
    </div>
  );
}
